export const EU_COUNTRY_CODES = new Set([
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
]);

export function isEuCountryCode(countryCode?: string | null): boolean {
  if (!countryCode) {
    return false;
  }
  return EU_COUNTRY_CODES.has(countryCode.trim().toUpperCase());
}

/** VIES only covers EU VAT IDs. Unknown or non-ISO country keeps the existing VIES check. */
export function shouldValidateVatIdViaVies(country?: string | null): boolean {
  const countryCode = country?.trim().toUpperCase();
  if (!countryCode || countryCode.length !== 2) {
    return true;
  }
  return isEuCountryCode(countryCode);
}
